import React, { Component } from 'react';
import { connect } from 'react-redux';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import axios from '../../../axios-url';
import {Dialog} from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import {MultiSelect} from 'primereact/multiselect';
import {Calendar} from 'primereact/calendar';
import { DROPDOWN_CONFIG, DATATABLE_CONFIG, APPROVAL_PATH_SUBMENU_ID} from '../../../shared/Config';
import { Levels, HASACCESS } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';


class Assigning extends Component {
    state = {
        selectedData : [],
        processData : [],
        loading : false,
        display : false,
        type : 'Add',
        ProcessId: null,
        selectedLevel : null,
        selecteddepartment : null,
        blnRelevent : false,
        processName : '',
        approvalPath : null,

        jobLevel : 0,
        releventDept : null,
        releventOption : [],
        fromDate : new Date('2020-01-01'),
        toDate : new Date('2070-01-01'),
        ddlProcessData : [],
        moduleId : null,
        processId : null,
        approvalPathMapId : null
    }



    deleteAssigning = () => {

        if(this.state.selectedData.length > 0){
            this.setState({loading : true});
            const updatedValue = this.state.selectedData.map( value => {
                return value.id;
            });    
            const filteredValue = this.state.processData.filter(item => {    
                return updatedValue.includes(item.id) === false;
             
            });
     

            axios.post('/master/api/DeleteAssigning',JSON.stringify(this.state.selectedData))
            .then(response =>{
                if(response.status === 200){
                    this.growl.show({severity: 'success', summary: null, detail: 'Deleted Successfully.'});
                    this.setState({processData:filteredValue});
                    localStorage.setItem('processData',JSON.stringify(filteredValue));
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })  
            this.setState({selectedData:[]})
        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select atleast one checkbox'});
        }


    }


    editItem = (rowData,type) => {
       

        this.getProcess(rowData.moduleNum);
        this.releventDepartment(rowData.requestTypeId);

        let moduelNum = rowData.moduleNum.toString();
        this.setState({approvalPathMapId : rowData.approvalPathMapId,display:true,approvalPath:rowData.approvalPathId, moduleId : moduelNum, jobLevel:rowData.requestTypeId,
            fromDate:new Date(rowData.fromDate),toDate:new Date(rowData.toDate), type: type, blnRelevent:true})

        setTimeout(() => {
            this.setState({processId:rowData.processId,releventDept:rowData.releventId})
        },2000)
    }


    clear = () => {
        this.setState({approvalPathMapId : null, display:false,blnRelevent:false,approvalPath:null,moduleId:null,jobLevel:null,fromDate:new Date(),toDate:new Date(),processId:null,releventDept:null, type : 'Add'})
    }




    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button type="button" icon="pi pi-pencil" onClick={() => this.editItem(rowData,'Edit')}  className="p-button-info"></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Button type="button" icon="pi pi-eye" onClick={() => this.editItem(rowData,'View')}  className="p-button-secondary"></Button>
            }
          </div>;
    }

    componentDidMount(){
       // this.releventDepartment(6);

        this.props.getMasterKeywordList('OrgUnit');
        this.getAssigningList();
        this.getAccess = HASACCESS(APPROVAL_PATH_SUBMENU_ID);
    }


    
    getAssigningList = () => {    
        
            this.setState({loading : true});
            axios.get('/master/api/GetAssigning')
            .then(response =>{
                if(response.status === 200){
                    this.setState({processData:response.data});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })    
    }

    export = () => {
        this.dt.exportCSV();
    }




    updateDetail = (e) => {
        const { name, value} = e.target;
       
        this.setState({[name]:value})
        if(name === "moduleId") {       
            this.getProcess(value);
        } else if (name === "jobLevel") {
            this.releventDepartment(value);
        } 
    }

    
    getProcess = (value) => {   
        this.setState({loading : true});
        axios.get('/master/api/GetProcesses?Id='+value)
        .then(response =>{
            if(response.status === 200){
                let processData = response.data.map( pro => {
                    return { label : pro.processDescription, value: pro.processId}
                });
                this.setState({ddlProcessData:processData});
              
            }
            this.setState({loading : false});
        })
        .catch(err => {
            this.setState({loading : false});
        })    
    }

    releventDepartment = (value) => {
        this.setState({loading : true});

        var url = value === 1 ? "/master/api/DropDownValues/Employee" : value === 2 ? "/master/api/GetSection" :
        value === 3 ? "/master/api/GetDepartment" : value === 4 ? "/master/api/GetDivision" : value === 5 ? "/master/api/GetCompany" : value === 6 ? "/master/api/DropDownValues/OrgUnit" : "";
        // const relavantList = localStorage.getItem('relavantList_'+value);
        // if(!relavantList){
            axios.get(url)
            .then(response =>{
                if(response.status === 200){
                    let data = []
                    if(response.data.length > 0) {
                        
                            data = response.data.map(val => {
                                return { "label": val.text,"value":val.uniqueId,"id":val.id }
                            })  
                        
                    }
                    
                    if(value === 6){
                        let companyIDVAL = this.props.loggedUserDetail.CompanyId.toLowerCase();
                        data.unshift({"label": "Company","value":companyIDVAL,"id":companyIDVAL})
                    }
                    //localStorage.setItem('relavantList_'+value,JSON.stringify(data));
                    this.setState({releventOption:data,blnRelevent:true});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })
        // }else{
        //     this.setState({releventOption:JSON.parse(relavantList),blnRelevent:true,loading : false});
        // }
    }

   
    relavantRender = (rowData) => {

        if(rowData.requestTypeId === 1){
            return rowData.releventDept;
        }else{
            let orgData  = this.props.GetOrgUnit;
            let relavantData ='';
            if(orgData && orgData.length > 0){
                 relavantData = orgData.filter(list => {
                    return list.value === rowData.releventId
                }).reduce((_,el) => {
                    return el.label
                },'')
            }  
            return relavantData; 
        }
    }

    addAssigning = () => {

        this.setState({loading : true});
        let releventDept = null
        if(this.state.releventDept !==null){
            releventDept = this.state.releventDept;
        }
        var data = [];
        if(this.state.type === 'Add'){
            data = [{    
                ApprovalPathId: this.state.approvalPath,
                MappingEntityId: releventDept,
                IsActive : true,
                RequestTypeId : this.state.jobLevel,
                FromDate: this.state.fromDate,           
                ToDate: this.state.toDate,         
                CompanyId :  this.props.loggedUserDetail.CompanyId,
            }];
        }else{
            data = [{   
                ApprovalPathMapId    : this.state.approvalPathMapId, 
                ApprovalPathId: this.state.approvalPath,
                MappingEntityId: releventDept,
                IsActive : true,
                RequestTypeId : this.state.jobLevel,
                FromDate: this.state.fromDate,           
                ToDate: this.state.toDate,         
                CompanyId :  this.props.loggedUserDetail.CompanyId,
            }];
        }

        let finalData = {
            ApprovalPathMapping : data
        }

        let url = (this.state.type === 'Edit') ? '/master/api/UpdateDynamicData?model=ApprovalAssign' : '/master/api/InsertDynamicData?model=ApprovalAssign';

        let message = (this.state.type === 'Edit') ? 'Assigning updated successufully' : 'Assigning added successufully';
        var dd = JSON.stringify(finalData);
        var datas = {Key : dd};
        axios.post(url,JSON.stringify(datas))
            .then(response =>{
                if(response.data.statusCode === 1){
                    this.growl.show({severity: 'success', summary: null, detail: message});   
                    this.clear();
                    this.getAssigningList();                
             
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                }
                this.setState({loading : false});
                
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })  


    }


    onLevelChange =(event) => {
        this.dt.filter(event.value, 'requestTypeId', 'in');
        this.setState({selectedLevel : event.value});
    }



    renderLevelFilter(levels) {
        return (
            <MultiSelect  style={{width:'100%'}} className="p-column-filter" value={this.state.selectedLevel} options={levels}
                onChange={this.onLevelChange} placeholder="Select Level" />
        );
    }



      //is Level
    level = (rowData) => {
        var d = rowData.requestTypeId === 1 ? 'Employee' : 'Organization Unit' ;
        return <span >{d}</span>
    }


   

  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        let ddlapprovalPath = [];
     
        if(this.state.processId !=null){
            ddlapprovalPath = this.props.approvalOption.filter(list=>{
                return list.processId === this.state.processId;
            })
        }

        let isEnabled = (this.state.moduleId !== null )  && (this.state.processId !== null )  && (this.state.fromDate !== '' ) && (this.state.toDate !== '') && (this.state.approvalPath !== null) && (this.state.jobLevel !== 0 );
     
        var filterLevelItems = [1,6];
        let levels = Levels.filter(level=> {
            return filterLevelItems.includes(level.value);
        })
        


        const levelFilter = this.renderLevelFilter(levels);

      

        let selectName ='Select';
        if(this.state.jobLevel === 1) {
            selectName = 'Select Employee';
        } else if(this.state.jobLevel === 6) {
            selectName = 'Select Organization Unit';
        }

        let name = 'Update';
        let save = name;
        if(this.state.type === 'Add'){
            name = 'Add';
            save = 'Save';
        }else if(this.state.type=== 'View'){
            name = 'View';
        }


        const dialogFooter = (
            <div>
                { ((this.state.type === 'Add' && this.getAccess!==undefined && this.getAccess.addAccess!== false) || 
                    (this.state.type === 'Edit' && this.getAccess!==undefined && this.getAccess.editAccess!== false)) &&
                <Button disabled={!isEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addAssigning} label={save} />
                }
                <Button icon="pi pi-times" onClick={this.clear} label="Cancel" className="p-button-secondary" />
            </div>
        )   

        return (
            <div className="p-grid">
                { this.state.loading && <div className="page-loader"></div>}
                <Toast ref={(el) => this.growl = el} />    
                <div className="p-col-12 p-lg-12">
                    <div className="mt1">
                    {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                    <Button style={{float: 'right'}} label="Add" icon="pi pi-plus" className="ml1" onClick={()=>this.setState({display:true})} />
                    }
                    {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                    <Button onClick={this.deleteAssigning} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger ml1"/>
                    }
                    <Button onClick={this.export} style={{float: 'right'}} label="Export" icon="pi pi-download"  className="p-button-secondary"/>
                    </div>                                
                </div>
           

               
            <div className="p-col-12" style={{marginTop:'2em'}}>
                <DataTable  selection={this.state.selectedData} 
                    onSelectionChange={e => this.setState({selectedData: e.value})} value={this.state.processData} ref={(el) => { this.dt = el; }} {...DATATABLE_CONFIG}>
                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                    <Column field="process" filterPlaceholder="Process" filter={true} sortable={true} header="Process" />
                    <Column field="approvalPath" filter={true} filterPlaceholder="Approval Path"  header="Approval Path" />                           
                    <Column field="releventDept" body={this.relavantRender} filter={true} filterPlaceholder="Relevent Data" header="Relevent Data" />
                    <Column field="requestTypeId" body={this.level}  filterElement={levelFilter} filter={true} filterPlaceholder="Level"  header="Level" />
                    <Column body={this.actionTemplate} header="Action" />
                </DataTable>
            </div>

            <Dialog header={ name + " Assigning"} visible={this.state.display} modal={true}  style={{width: '50vw'}} footer={dialogFooter} onHide={this.clear} blockScroll >

                <div className="p-grid">

                    <div className="p-col-12 p-lg-6">
                        <label className="label">Module<span className="requiredColor">*</span></label>
                        <div className="mt1">
                            <Dropdown placeholder="Select Module" name="moduleId" value={this.state.moduleId} options={this.props.ddlModuleData} onChange={(e) => this.updateDetail(e)}   {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                        </div> 
                    </div>

                    <div className="p-col-12 p-lg-6">
                                <label className="label">Process<span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Process Name" name="processId" value={this.state.processId} options={this.state.ddlProcessData} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div>
                            </div>
           
                    <div className="p-col-12 p-lg-6" style={{display:'none'}}>
                        <label className="label">From Date</label>
                        <div className="mt1">
                        <Calendar  dateFormat="dd/mm/yy" className="width100" value={this.state.fromDate} appendTo={document.body} onChange={(e) => this.setState({fromDate:e.value})}  monthNavigator={true} yearNavigator={true} yearRange="2010:2030"/>

                        </div> 
                    </div>

                    <div className="p-col-12 p-lg-6" style={{display:'none'}}>
                        <label className="label">To Date</label>
                        <div className="mt1">
                        <Calendar dateFormat="dd/mm/yy"   className="width100" value={this.state.toDate} appendTo={document.body} onChange={(e) => this.setState({toDate:e.value})}  monthNavigator={true} yearNavigator={true} yearRange="2010:2030"/>

                        </div> 
                    </div>

                    
                    <div className="p-col-12 p-lg-12">
                        <label className="label">Approval Path</label>
                        <div className="mt1">
                            <Dropdown placeholder="Select Approval Path"  name="approvalPath"  value={this.state.approvalPath} options={ddlapprovalPath} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }} />                                        
                        </div> 
                    </div>


                    <div className="p-col-12 p-lg-12">
                        <label className="label">Level</label>
                        <div className="mt1">
                        
                        <Dropdown placeholder="Select Level" name="jobLevel" value={this.state.jobLevel} options={levels} onChange={(e) => this.updateDetail(e)}  {...DROPDOWN_CONFIG}  style={{ width: '100%' }}/>

                        </div>   
                    </div>

                    { this.state.blnRelevent === true &&


                        <div className="p-col-12 p-lg-12">
                            <label className="label">{selectName}</label>
                            <div className="mt1">
                            <Dropdown placeholder={selectName} name="releventDept" value={this.state.releventDept} options={this.state.releventOption} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG}  style={{ width: '100%' }}/>

                            </div>   
                        </div>

                    }
                    
                  
                    
                
        
                </div>



            </Dialog>


        </div>
            );
    }
}


const mapStateToProps = state => {
    return{
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Assigning);